import React, { PureComponent, Fragment} from 'react';
import injectSheet from 'react-jss'
import cn from "classnames";
import { connect } from 'react-redux'
import flow from 'lodash/flow'
import ShopIcon from "../Widgets/ShopIcon"
import ShopTheLookItem from "../ShopThLook/ShopTheLookItem"
import {
    getIsLoadingProducts, getProducts, getProductsLoaded, isUsingUniversalMenu,
    showAddToBag
} from "../../selectors";
import {fetchProducts} from "../../actions";
import chevron from '../../img/icons/chevron.svg'
import SVGSymbol from '../SVGSymbol'

class ShopTheLookCarousel extends PureComponent {

    componentWillUnmount() {
        this._unmounting = true;
        this._destroyFlikity();
    }

    componentDidMount() {
        this._init();
    }

    componentDidUpdate() {
        this._init();
    }


    _init = () => {
        if (this._unmounting) return;
        this._initFlickity(this._girdContainer);

        const { handleFetchProducts, loadingProducts, productsLoaded, id, shopItems } = this.props;

        if(loadingProducts) return;
        if(productsLoaded) return;
        if(!shopItems || shopItems.length === 0) return;

        handleFetchProducts(id, shopItems);
    }

    _destroyFlikity = () => {
        const {flktyRef} = this.props;
        if (this.flkty) {
            this.flkty.destroy()
            delete this.flkty
            if(flktyRef) flktyRef(null)
        }
    }

    _setGirdContainer = (ref) => this._girdContainer = ref;

    _initFlickity = (ref) => {

        const {flktyRef, groupCells, shopItems, isMobile = false} = this.props;

        if (!ref && this.flkty) {
            this.flkty.destroy();
            if(flktyRef) flktyRef(null)
        }

        if (!ref )return;

        if (this.flkty && this.flkty.element !== ref) {
            this.flkty.destroy()
            delete this.flkty
            if(flktyRef) flktyRef(null)
        }

        if (this.flkty) {
            this.flkty.resize();
            return;
        }

        import(/* webpackChunkName: 'flickity' */ 'flickity').then(module => {

            ref.style.maxWidth = 'auto'
            ref.style.display = 'block'

            this.flkty = new module(ref, {
                // options
                cellAlign: isMobile ? 'left' : shopItems.length === 1 ? 'center' : 'left',
                contain: true,
                wrapAround: false,
                pageDots: false,
                prevNextButtons: false,
                groupCells: groupCells
            })
            if(flktyRef) flktyRef(this.flkty)
        });

    }

    _previous = () => {
        if(this.flkty) this.flkty.previous();
    }

    _next = () => {
        if(this.flkty) this.flkty.next();
    }

    render() {
        const {classes, className, onClick, size='small', showAddToBag, showTitle=true, shopItems,
            productsLoaded, universalMenu, showNextPrevButtons, overflow=true, title} = this.props;
        const products = productsLoaded ? this.props.products : shopItems;

        return (<Fragment>
            {products && products.length > 0 &&
            <div className={cn(classes.productsContainer, {overflow}, className)} onClick={onClick} data-cy="shopTheLookCarousel">
                {(showTitle || showNextPrevButtons) && (
                  <div className={classes.shopTitleContainer} data-cy="ShopTheLookCarouselTitle">
                    {showTitle && (
                        <div className={classes.shopTitle}>
                            <ShopIcon/>{title ? title : "Shop The Look"}
                        </div>
                    )}
                    {products && products.length > 3 && showNextPrevButtons && (
                        <div className={classes.prevNextContainer}>
                            <a className={cn(classes.button, 'previous')} onClick={this._previous}><SVGSymbol icon={chevron}/></a>
                            <a className={cn(classes.button, 'next')} onClick={this._next}><SVGSymbol icon={chevron}/></a>
                        </div>
                    )}
                  </div>
                )}
                <div ref={this._setGirdContainer} className={classes.shopItems} data-cy="ShopTheLookCarouselItems">
                    {products.map((item, i) => <ShopTheLookItem key={i}
                                                    size={size}
                                                    item={item}
                                                    universalMenu={universalMenu}
                                                    showAddToBag={showAddToBag}/>)}
                </div>
            </div>
            }
        </Fragment>)
    }
}

const mapStateToProps = (state, props) => {
    return {
        universalMenu: isUsingUniversalMenu(state),
        showAddToBag: showAddToBag(state),
        loadingProducts: getIsLoadingProducts(state, props.id),
        productsLoaded: getProductsLoaded(state, props.id),
        products: getProducts(state, props.id),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        handleFetchProducts: (id, items) => {
            dispatch(fetchProducts(id, items));
        }
    }
}

export default flow([
    injectSheet(theme => ({
        productsContainer: {
            zIndex: theme.zIndex.carousel,
            flexGrow: 1,
            overflow: 'hidden',
            '& div': {
                '-webkit-tap-highlight-color': 'transparent',
                'tap-highlight-color': 'transparent',
                '-webkit-user-select': 'none',
                '-moz-user-select': 'none',
                '-ms-user-select': 'none',
                'user-select': 'none',
                outline: 'none',
            },
            '&.overflow': {
                overflow: 'visible'
            }
        },
        shopItems: {},
        product: {
          flexShrink: 0,
          '&.small': {
              width: 120,
              [theme.breakpoint('mobile')]: {
                  width: 130,
              },
          },
          '&.medium': {
              width: 150,
              [theme.breakpoint('mobile')]: {
                  width: 198,
              },
          }
        },
        productContentContainer: {
            padding: 0,
            position: 'relative',
            fontSize: theme.getRemValue(10),

        },
        productTitle: {
            fontSize: theme.getRemValue(10),
            paddingRight: 14, // icon width
            lineHeight: '0.8rem',
        },
        productSummary: {
            lineHeight: '1.2em',
            '&.noBrand': {
                paddingRight: 14, // icon width
            }
        },
        productPrice: {
            fontSize: theme.getRemValue(10),
            lineHeight: '1.2em'
        },
        productRibbon: {
            marginTop: '0.3rem'
        },
        wishlistIconContainer: {
            width: 16,
            height: 16,
            top: 1,
            right: 5,
            position: 'absolute'
        },
        wishlistIcon: {
            left: 0,
            width: 16,
            height: 16,
            color: '#222222'
        },
        shopTitleContainer: {
            fontSize: theme.getRemValue(12),
            fontWeight: 600,
            letterSpacing: 0.4,
            display: 'flex',
            alignItems: 'center',
            textTransform: 'uppercase',
            marginBottom: theme.spacing.tiny,
            justifyContent: 'flex-end'
        },
        shopTitle: {
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            '& svg': {
                marginRight: theme.spacing.tiny,
                width: 14,
                height: 14
            }
        },
        prevNextContainer: {
            display: 'none',
            [theme.breakpoint('tablet')]: {
                display: 'block',
            }
        },
        button: {
            margin: [0, '0.3rem'],
            "& svg": {
                color: theme.colors.assent,
                width: 16,
                height: 16
            },
            "&:hover svg": {
                color: theme.colors.primary,
            },
            "&.previous svg": {
                transform: 'rotate(90deg)',
            },
            "&.next  svg": {
                transform: 'rotate(-90deg)'
            },
        },
    })),
    connect(mapStateToProps, mapDispatchToProps)
])( ShopTheLookCarousel );



// WEBPACK FOOTER //
// ./src/components/ShopThLook/ShopTheLookCarousel.js